import PageMetaFolder from './page-meta-folder.js';
new PageMetaFolder();

// Dispatch resize event after sidebar (un)folds
for ( const bar
			of document.querySelectorAll( '.left-sidebar, .right-sidebar' ) ) {
	bar.addEventListener(
		'transitionend',
		() => { window.dispatchEvent( new Event( 'resize' ) ); }
	);
}

import ModalOpenPositionFix from './modal-open-position-fix.js';
new ModalOpenPositionFix();
